import { AiKnowledgeBaseToolTip } from 'src/pages/AIKnowledgeBasePage/AiKnowledgeBaseToolTip';
import { CheckboxKnowledgeBasePage } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseTableList/CheckboxKnowledgeBase';
import { TableCell } from 'src/components/ui/table';
import { EditKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/edit/EditKnowledgeBaseIntegrationModal/EditKnowledgeBaseIntegrationModal';
import { DeleteKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/delete/DeleteKnowledgeBaseIntegrationModal/DeleteKnowledgeBaseIntegrationModal';
import { SyncKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/SyncKnowledgeBaseIntegrationModal/SyncKnowledgeBaseIntegrationModal';
import { useAppSelector } from 'src/store';
import type { TreeNode } from 'src/utils/fileUtils';
import type { KnowledgeBaseItemFlags } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseTableList/CurrentKnowledgeBaseTableRow/CurrentKnowledgeBaseTableRow';
import type { ItemCheckHandler } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseTableList/knowledgeBaseItemHandlers';

export const ActionCellIntegration = ({
  item,
  is,
  checked,
  onChange,
}: {
  item: TreeNode;
  is: KnowledgeBaseItemFlags;
  checked?: boolean;
  onChange?: ItemCheckHandler;
}) => {
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);

  return item.data ? (
    <TableCell padding={'p-5'} className="max-w-80 !rounded-tr-none">
      <div
        role="none"
        className="flex items-center justify-end gap-7.5 [&:has([role=checkbox])]:pr-5"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onDoubleClick={(e) => {
          e.stopPropagation();
        }}
      >
        <AiKnowledgeBaseToolTip
          side={'top'}
          trigger={
            <div>
              <SyncKnowledgeBaseIntegrationModal item={item} disabled={isInactivePlan} />
            </div>
          }
          content={<span className={'text-xs opacity-50 text-ebony'}>Sync</span>}
        />
        {item.data.type !== 'web_scrapper' && (
          <AiKnowledgeBaseToolTip
            side={'top'}
            trigger={
              <div>
                <EditKnowledgeBaseIntegrationModal item={item} />
              </div>
            }
            content={<span className={'text-xs opacity-50 text-ebony'}>Settings</span>}
          />
        )}
        <AiKnowledgeBaseToolTip
          side={'top'}
          trigger={
            <div>
              <DeleteKnowledgeBaseIntegrationModal item={item} />
            </div>
          }
          content={<span className={'text-xs opacity-50 text-ebony'}>Delete</span>}
        />
        {(is.delete || is.move) && (
          <CheckboxKnowledgeBasePage
            className={'invisible'}
            checked={checked}
            item={item}
            onChange={onChange}
            disabled
          />
        )}
      </div>
    </TableCell>
  ) : (
    <TableCell padding={'p-5'} className="max-w-80 !rounded-tr-none"></TableCell>
  );
};
